import AdvancedController from "./advanced-controller"
import { slideIn, slideOut, extendHeight } from "../animations/animation-slide";

export default class AccordionItemController extends AdvancedController {

  static targets = ['item', 'body'];

  static values = {
    isOpen: Boolean
  }

  connect() {
    super.connect(...arguments);
    const accordionEl = this.element.closest('.block__accordion')
    this._accordionController = accordionEl['accordion']
    this._accordionController.messageItemConnected(this)
  }

  onToggle() {
    this.isOpenValue = !this.isOpenValue
    this._handleState();
  }

  messageClose() {
    this.isOpenValue = false
    this._handleState();
  }

  messageOpen() {
    this.isOpenValue = true
    this._handleState();
  }

  _handleState() {
    const contentBlocker = this.bodyTarget.querySelector('[data-borlabs-cookie-unblock]');

    if (this.isOpenValue) {
      slideIn(this.bodyTarget)
      this._accordionController.messageAddActive(this)
      this.itemTarget.classList.add('-active');
      
      // listen for content blocker unblocking
      if (contentBlocker) {
        contentBlocker.addEventListener('click', () => {
          const newHeight = this.bodyTarget.querySelector('.block__accordion__item__content').offsetHeight;
          extendHeight(this.bodyTarget, newHeight);
        });
      }
    } else {
      slideOut(this.bodyTarget);
      this.itemTarget.classList.remove('-active');
      contentBlocker?.removeEventListener('click', () => {});
    }
  }

}
